import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { selectCouponSelectedBetsV2, selectSystemBaseV2, setCouponSelectedSystemBaseV2, useToggle } from '@mwl/core-lib';
import type { OptionListClasses, SelectOption } from '@mwl/ui';
import { OptionList } from '@mwl/ui';
import ArrowDownIcon from '@public/assets/common/icons/arrow.svg';
import type { DropdownClasses } from '@/components/Dropdown/Dropdown';
import { Dropdown } from '@/components/Dropdown/Dropdown';
import { useTypedDispatch, useTypedSelector } from '@/hooks';
import type { CouponSystemRegularityProps } from './CouponSystemRegularity.types';
import styles from './CouponSystemRegularity.module.scss';
const systemMinValue = 2;
const dropdownItemClasses: OptionListClasses = {
  option: styles.dropdownItem
};
const dropdownClasses: DropdownClasses = {
  container: styles.dropdownContainer
};
const CouponSystemRegularity: FC<CouponSystemRegularityProps> = ({
  active
}) => {
  const {
    t
  } = useTranslation('sport');
  const dispatch = useTypedDispatch();
  const selectedBets = useTypedSelector(selectCouponSelectedBetsV2);
  const systemSelectedValue = useTypedSelector(selectSystemBaseV2);
  const [isOpened, toggleOpened] = useToggle(false);
  const betsCount = selectedBets.length;
  const options = useMemo(() => {
    const result: Array<SelectOption> = [];
    for (let i = systemMinValue; i < betsCount; i += 1) {
      result.push({
        label: `${i}/${betsCount}`,
        value: String(i)
      });
    }
    return result;
  }, [betsCount]);
  const handleSelect = useCallback((newValue: SelectOption) => {
    dispatch(setCouponSelectedSystemBaseV2(parseInt(newValue.value, 10)));
    toggleOpened();
  }, [dispatch, toggleOpened]);
  const selectedItem = useMemo(() => {
    const value = systemSelectedValue || betsCount - 1;
    return options.find(option => option.value === String(value));
  }, [betsCount, systemSelectedValue, options]);
  const dropdownHeader = <div className={styles.dropdownHeader}>
      <div className={cn(styles.dropdownHeaderText, {
      [styles.active]: active
    })}>{selectedItem?.label}</div>
      <div className={styles.dropdownIconWrapper}>
        <ArrowDownIcon className={cn(styles.dropdownIcon, {
        [styles.dropdownIconOpened]: isOpened
      })} />
      </div>
    </div>;
  if (!options.length) {
    return null;
  }
  return <Dropdown customHeader={dropdownHeader} active={isOpened} onToggle={toggleOpened} className={styles.root} classes={dropdownClasses} variant="default" placement="bottom-end" data-sentry-element="Dropdown" data-sentry-component="CouponSystemRegularity" data-sentry-source-file="CouponSystemRegularity.tsx">
      <OptionList options={options} classes={dropdownItemClasses} selected={selectedItem} onSelect={handleSelect} renderOption={({
      option,
      selected
    }) => <button type="button" onClick={() => handleSelect(option)} className={cn(styles.option, {
      [styles.active]: selected
    })}>
            {t('coupon.type.system', 'System')}
            <div className={styles.optionValue}>{option.label}</div>
          </button>} data-sentry-element="OptionList" data-sentry-source-file="CouponSystemRegularity.tsx" />
    </Dropdown>;
};
export { CouponSystemRegularity };